import { createAsyncThunk } from '@reduxjs/toolkit';
import crmStatusApi from '~/apis/crm-status';

import { CREATE_CRM_STATUS, EDIT_CRM_STATUS, GET_CRM_STATUS, GET_CRM_STATUSES } from '~/utils/constants/actionType';
import { ICRMStatus, IParamsGetCRMStatus, IResponseGetCRMStatus, IUpdatePosition } from '~/utils/interface/crm-status';

export const handleCreateCRMStatus = createAsyncThunk<ICRMStatus, ICRMStatus>(
  CREATE_CRM_STATUS,
  async (data: ICRMStatus, { rejectWithValue }) => {
    try {
      const res = await crmStatusApi.create(data);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
export const handleGetCRMStatuses = createAsyncThunk<IResponseGetCRMStatus, IParamsGetCRMStatus>(
  GET_CRM_STATUSES,
  async (params: IParamsGetCRMStatus = {}, { rejectWithValue }) => {
    try {
      const res = await crmStatusApi.getList(params);

      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGetCRMStatus = createAsyncThunk<ICRMStatus, string>(
  GET_CRM_STATUS,
  async (id: string, { rejectWithValue }) => {
    try {
      const res = await crmStatusApi.getDetail(id);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
export const handleEditCRMStatus = createAsyncThunk<ICRMStatus, { id: string; params: ICRMStatus }>(
  EDIT_CRM_STATUS,
  async ({ id, params }, { rejectWithValue }) => {
    try {
      const res = await crmStatusApi.update(id, params);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleUpdateposition = createAsyncThunk<ICRMStatus, { id: string; params: IUpdatePosition }>(
  'UPDATE_POSITION',
  async ({ id, params }, { rejectWithValue }) => {
    try {
      const res = await crmStatusApi.updatePosition(id, params);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
